import React, {useContext} from "react"
import Link from "next/link"
import CheckBoxField from "../forms/fields/CheckBoxField"
import {useRouter} from "next/router"
import {useFormikContext} from "formik"
import Typography from "../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"
import LayoutContext from "../../context/LayoutContext"

const TermsAndConditionsCheckbox = () => {
	const router = useRouter()
	const {errors, touched} = useFormikContext()
	const {isMobile} = useContext(LayoutContext)
	const {t} = useTranslation()
	const linkStyles = isMobile ? "px-1 text-decoration-none rounded-3 lh-lg text-dark bg-primary" : ""

	return (
		<>
			{router.locale === "de" ?
				<CheckBoxField name={"all_agb"}>
					<>
						<span>
					Ich habe die
						</span>
						{" "}
						<Link href={"/terms-conditions"}>
							<a className={`${linkStyles}`}
								target={"_blank"}>
								AGB
							</a>
						</Link>
						{" "}
						<span>
					und die
						</span>
						{" "}
						<Link href={"/datenschutz"}>
							<a className={`${linkStyles}`}
								target={"_blank"}>
								Datenschutzerklärung
							</a>
						</Link>
						{" "}
						<span>
					der Mybikeplan AG und jene von
						</span>
						{" "}
						<Link href={"https://www.swissbilling.ch/wp-content/uploads/swb-agb.pdf"}>
							<a className={`${linkStyles}`}
								target={"_blank"}>
								Swissbilling
							</a>
						</Link>
						{" "}
						<span>
					sowie von
						</span>
						{" "}
						<Link href={"/agb/AGB_POSP00016512_2024-10-23.pdf"}>
							<a className={`${linkStyles}`}
								target={"_blank"}>
								MFGroup
							</a>
						</Link>
						{" "}
						<span>
					gelesen und akzeptiere diese.
						</span>
					</>
				</CheckBoxField> : router.locale === "fr" ?
					<CheckBoxField name={"all_agb"}>
						<>
							<span>
					J’ai lu et accepte les
							</span>
							{" "}
							<Link href={"/terms-conditions"}>
								<a className={`${linkStyles}`}
									target={"_blank"}>
									conditions générales
								</a>
							</Link>
							{" "}
							<span>
					et la
							</span>
							{" "}
							<Link href={"/datenschutz"}>
								<a className={`${linkStyles}`}
									target={"_blank"}>
									politique de confidentialité
								</a>
							</Link>
							{" "}
							<span>
					de Mybikeplan AG ainsi que celles de
							</span>
							{" "}
							<Link href={"https://www.swissbilling.ch/wp-content/uploads/swb-agb.pdf"}>
								<a className={`${linkStyles}`}
									target={"_blank"}>
									Swissbilling
								</a>
							</Link>
							{" "}
							<span>
					et
							</span>
							{" "}
							<Link href={"/agb/AGB_POSP00016512_2024-10-23.pdf"}>
								<a className={`${linkStyles}`}
									target={"_blank"}>
									MFGroup
								</a>
							</Link>
							{" "}
							<span>
                            .
							</span>
						</>
					</CheckBoxField> : null
			}
			{/* @ts-ignore */}
			{(errors && errors.all_agb && touched.all_agb) ? (
				// @ts-ignore
				<Typography variant="bodyLg"
					semanticTag="div"
					className={"text-danger mb-5"}>{t("required")}</Typography>
			) : null}
		</>
	)
}

TermsAndConditionsCheckbox.propTypes = {

}

export default TermsAndConditionsCheckbox
